import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PageHeader, DataCard, StatusPill } from "@/components/admin/AdminPrimitives";
import { Skeleton } from "@/components/ui/skeleton";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/categorias")({
  head: () => ({ meta: [{ title: "Categorias — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: CategoriasAdmin,
});

function CategoriasAdmin() {
  const list = useQuery({
    queryKey: ["admin.categorias"],
    queryFn: async () => {
      const [cats, biz] = await Promise.all([
        supabase.from("categories").select("*").order("sort_order"),
        supabase.from("businesses").select("category_id"),
      ]);
      const counts = new Map<string, number>();
      for (const b of (biz.data ?? []) as any[]) {
        if (!b.category_id) continue;
        counts.set(b.category_id, (counts.get(b.category_id) ?? 0) + 1);
      }
      return (cats.data ?? []).map((c: any) => ({ ...c, count: counts.get(c.id) ?? 0 }));
    },
  });
  return (
    <div>
      <PageHeader
        title="Categorias"
        description="Organize a taxonomia da biblioteca."
        actions={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-3 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Nova categoria
          </button>
        }
      />
      {list.isLoading ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3"><Skeleton className="h-32 rounded-2xl" /><Skeleton className="h-32 rounded-2xl" /><Skeleton className="h-32 rounded-2xl" /></div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {(list.data ?? []).map((c: any) => (
            <DataCard key={c.id}>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <StatusPill tone={c.active ? "green" : "gray"}>{c.active ? "Ativa" : "Inativa"}</StatusPill>
                  <span className="text-xs font-semibold text-[var(--gray-ink)]">#{c.sort_order}</span>
                </div>
                <h3 className="mt-3 font-display text-base font-extrabold text-[var(--navy)]">{c.name}</h3>
                <p className="mt-1 line-clamp-2 text-sm text-[var(--gray-ink)]">{c.description ?? "—"}</p>
                <p className="mt-3 text-xs font-semibold text-[var(--gold)]">{c.count} negócios</p>
              </div>
            </DataCard>
          ))}
        </div>
      )}
    </div>
  );
}
